var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCashExpense(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_672_21725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.136014 28.9822C-0.180725 28.485 0.0909034 27.677 0.588411 27.677H2.03582L2.03551 19.4123C2.03551 18.9771 2.2617 18.6667 2.57813 18.6667H4.25143C4.56817 18.6667 4.79405 18.9775 4.79405 19.4123L4.79437 27.677H6.24178C6.73929 27.677 7.01059 28.4226 6.69417 28.9822L3.89021 33.8292C3.66401 34.202 3.21194 34.202 2.98576 33.8292L0.136014 28.9822Z",
    fill: "#7F5579"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.864 28.9822C40.1807 28.485 39.9091 27.677 39.4116 27.677H37.9642L37.9645 19.4123C37.9645 18.9771 37.7383 18.6667 37.4219 18.6667H35.7486C35.4318 18.6667 35.2059 18.9775 35.2059 19.4123L35.2056 27.677H33.7582C33.2607 27.677 32.9894 28.4226 33.3058 28.9822L36.1098 33.8292C36.336 34.202 36.7881 34.202 37.0142 33.8292L39.864 28.9822Z",
    fill: "#7F5579"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 4.66675C14.0159 4.66675 9.15088 9.53182 9.15088 15.5161C9.15088 21.5003 14.0159 26.3654 20.0002 26.3654C25.9845 26.3654 30.8495 21.5003 30.8495 15.5161C30.8495 9.53182 25.9845 4.66675 20.0002 4.66675ZM23.9516 11.7474H21.6675C21.9645 12.1584 22.17 12.6382 22.2843 13.1406H23.9516V14.7852L22.2843 14.785C21.9188 16.5209 20.3657 17.8228 18.5156 17.8228H18.1274L22.4671 22.2311L20.046 22.2312L16.0489 18.1884V16.0871H18.5157C19.4065 16.0871 20.1602 15.5388 20.48 14.7851H16.0489V13.1405H20.48C20.1602 12.364 19.4065 11.8385 18.5157 11.8385L16.0489 11.8387V10.1028H23.929V11.7474L23.9516 11.7474Z",
    fill: "#7F5579"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_672_21725"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashExpense);
export default __webpack_public_path__ + "static/media/CashExpense.29ccb2318b8c0ff67aa5594680385c4c.svg";
export { ForwardRef as ReactComponent };